<script setup lang="ts">
import { useCardHeadingLevel } from "./headingLevel";

/**
 * The title of a card inside a wizard step — "Name", "Above ground", "Heat supply".
 *
 * Exists only to get the LEVEL right: it renders whatever heading element sits one below the step's
 * own title, which depends on who is hosting the step (see headingLevel.ts). It was a hardcoded
 * `<h2>` at every one of these call sites, which was correct while a step was always a page of its
 * own and stopped being correct the moment the settings page put several steps on one page.
 *
 * Carries no styling of its own on purpose. Almost every call site uses `t-sh5 text-type-default`,
 * but one does not, and baking the common case in would leave that one merging two conflicting type
 * scales. The class stays where it was, so this swap changes the element and nothing else.
 */
const headingLevel = useCardHeadingLevel();
</script>

<template>
  <component :is="headingLevel">
    <slot />
  </component>
</template>
